import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

interface ErrorStateProps {
  error: Error | string
  onRetry?: () => void
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const message = typeof error === 'string' ? error : error.message
  return (
    <div className="alert alert-error max-w-2xl">
      <ExclamationTriangleIcon className="w-6 h-6" />
      <span className="font-semibold">Unable to load data</span>
      <span className="text-sm opacity-80">{message}</span>
      {onRetry ? (
        <button className="btn btn-sm" type="button" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  )
}
